import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Table,
  Row,
  Col
} from "reactstrap";

import { PanelHeader } from "components";

import { usershead as thead, usersbody as tbody } from "variables/general";
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';

const showPassword = false;

class Users extends React.Component {
  render() {
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row>
            <Col xs={12}>
              <Card className="lista-vpn">
                <CardHeader>
                  <CardTitle tag="h4">Lista de usuarios (4/31)  <Button type="primary" icon={<PlusOutlined />}>Añadir usuario</Button></CardTitle>
                  <p className="category"> Disponibles 27 usuarios</p>
                </CardHeader>
                <CardBody>
                <Button
                  icon={showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                  // onClick={togglePasswordVisibility}
                  // style={{ border: 'none', backgroundColor: 'transparent' }}
                >Mostrar contraseñas</Button>
                  <Table responsive striped bordered hover>
                    <thead className="text-primary">
                      <tr>
                        {thead.map((prop, key) => {
                          if (key === thead.length - 1)
                            return (
                              <th key={key} className="text-right">
                                {prop}
                              </th>
                            );
                          return <th key={key}>{prop}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {tbody.map((prop, key) => {
                        return (
                          <tr key={key}>
                            {prop.data.map((prop, key) => {
                              if (key === thead.length - 1)
                                return (
                                  <td key={key} className="text-right">
                                    {prop}
                                  </td>
                                );
                              return <td key={key}>{prop}</td>;
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/views/Users/Users.jsx